import type { Plugin } from "vue";
import { init, vueRouterInstrumentation } from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import router from "@/router";
import buildInfo from "@/assets/generated/build-info.json";
import useUserInfo from "@/composables/auth/useUserInfo";

const RESIZEOBSERVERSTR = "ResizeObserver";

export const registerSentry: Plugin = {
  install(app) {
    // Only install if not in development and sentry is enabled
    if (
      window.config.ENV !== "development" &&
      JSON.parse(window.config.IS_SENTRY_ENABLED)
    ) {
      init({
        app,
        beforeSend(event, hint) {
          // https://stackoverflow.com/a/50387233/994013
          // This is thrown when generating a scenario report and adding a
          // scenario to it. Can be ignored
          if (event.message && event.message.includes(RESIZEOBSERVERSTR))
            return null;
          const user = useUserInfo();
          return { ...event, user };
        },
        environment: window.config.SENTRY_ENV,
        dsn: window.config.SENTRY_DSN,
        release: buildInfo.BUILD_ID,
        integrations: [
          new BrowserTracing({
            routingInstrumentation: vueRouterInstrumentation(router),
            tracingOrigins: [window.location.hostname]
          })
        ],
        tracesSampleRate: 1.0
      });
    }
  }
};
